import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'resource',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'upload_captures' })
  }
}
